// import React, { useState, useEffect } from "react";
// import PropTypes from "prop-types";
// import { Link } from "react-router-dom";
// import clsx from "clsx";
// import MenuCart from "./sub-components/MenuCart";

// const IconGroup = ({ iconWhiteClass }) => {
//   const [cartItems, setCartItems] = useState(
//     JSON.parse(localStorage.getItem("cartItems")) || []
//   );

//   const [menuCartOpen, setMenuCartOpen] = useState(false);
//   const [isLoggedIn, setIsLoggedIn] = useState(false);

//   useEffect(() => {
//     const storedData = JSON.parse(localStorage.getItem("userDetails"));
//     if (storedData && storedData.accessToken) {
//       setIsLoggedIn(true);
//     }

//     const handleCartUpdated = (event) => {
//       setCartItems(event.detail);
//     };

//     window.addEventListener("cartUpdated", handleCartUpdated);

//     return () => {
//       window.removeEventListener("cartUpdated", handleCartUpdated);
//     };
//   }, []);

//   const handleClick = (e) => {
//     e.currentTarget.nextSibling.classList.toggle("active");
//   };

//   const handleLogout = () => {
//     localStorage.removeItem("userDetails");

//     setTimeout(() => {
//       setIsLoggedIn(false);
//     }, 100);

//     // Redirect to the homepage or login page after logout
//     window.location.href = process.env.PUBLIC_URL + "/login";
//   };

//   const triggerMobileMenu = () => {
//     const offcanvasMobileMenu = document.querySelector(
//       "#offcanvas-mobile-menu"
//     );
//     offcanvasMobileMenu.classList.add("active");
//   };

//   const cartItemCount = cartItems.reduce(
//     (total, item) => total + item.quantity,
//     0
//   );

//   return (
//     <div className={clsx("header-right-wrap", iconWhiteClass)}>
//       {/* Other components omitted for brevity */}
//       <div className="same-style account-setting d-none d-lg-block">
//         <button className="account-setting-active" onClick={handleClick}>
//           <i className="pe-7s-user-female"></i>
//         </button>
//         <div className="account-dropdown">
//           <ul>
//             {isLoggedIn ? (
//               <>
//                 <li>
//                   <Link to={process.env.PUBLIC_URL + "/account-profile"}>
//                    My Account
//                   </Link>
//                 </li>

//                 <li>
//                   <button
//                     onClick={handleLogout}
//                     style={{
//                       background: "none",
//                       border: "none",
//                       padding: 0,
//                       color: "#000",
//                       cursor: "pointer",
//                       fontSize: "14px",
//                     }}
//                   >
//                     Logout
//                   </button>
//                 </li>

//               </>
//             ) : (
//               <>
//                 <li>
//                   <Link to={process.env.PUBLIC_URL + "/login-register"}>
//                     Register
//                   </Link>
//                 </li>
//                 <li>
//                   <Link to={process.env.PUBLIC_URL + "/login"}>Login</Link>
//                 </li>
//               </>
//             )}
//           </ul>
//         </div>
//       </div>
//       <div className="same-style cart-wrap d-none d-lg-block">
//         <Link className="icon-cart" to={process.env.PUBLIC_URL + "/cart"}>
//           <i className="fa fa-shopping-cart" style={{ fontSize: "20px" }}></i>
//           <span className="count-style">{cartItemCount}</span>
//         </Link>
//         <MenuCart
//           cartItems={cartItems}
//           setCartItems={setCartItems}
//           isOpen={menuCartOpen}
//           onClose={() => setMenuCartOpen(false)}
//         />
//       </div>
//       &nbsp;&nbsp;
//       <div className="same-style cart-wrap d-none d-lg-block">
//         <Link className="icon-cart" to={process.env.PUBLIC_URL + "/Wishlist"}>
//           <i className="fa fa-heart" style={{ fontSize: "20px" }}></i>
//           {/* <span className="count-style">{cartItemCount}</span> */}
//         </Link>

//       </div>

//       {/* Mobile menu */}

//       <div className="same-style mobile-off-canvas d-block d-lg-none">
//         <Link className="icon-cart" to={process.env.PUBLIC_URL + "/cart"}>
//           <i className="fa fa-shopping-cart" style={{ fontSize: "20px" }}></i>
//           <span className="count-style">{cartItemCount}</span>
//         </Link>
//         {/* <MenuCart
//           cartItems={cartItems}
//           setCartItems={setCartItems}
//           isOpen={menuCartOpen}
//           onClose={() => setMenuCartOpen(false)}
//         /> */}
//       </div>
//       &nbsp;&nbsp;
//       <div className="same-style mobile-off-canvas d-block d-lg-none">
//         <Link className="icon-cart" to={process.env.PUBLIC_URL + "/Wishlist"}>
//           <i className="fa fa-heart" style={{ fontSize: "20px" }}></i>
//           {/* <span className="count-style">{cartItemCount}</span> */}
//         </Link>

//       </div>

//       <div className="same-style mobile-off-canvas d-block d-lg-none">
//         <button className="mobile-aside-button" onClick={triggerMobileMenu}>
//           <i className="fa fa-bars" style={{ fontSize: "20px" }}></i>
//         </button>
//       </div>
//     </div>
//   );
// };

// IconGroup.propTypes = {
//   iconWhiteClass: PropTypes.string,
// };

// export default IconGroup;

import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import clsx from "clsx";
import MenuCart from "./sub-components/MenuCart";

const IconGroup = ({ iconWhiteClass }) => {
  const [cartItems, setCartItems] = useState(
    JSON.parse(localStorage.getItem("cartItems")) || []
  );
  const [wishlistItems, setWishlistItems] = useState(
    JSON.parse(localStorage.getItem("wishlistItems")) || []
  );

  const [menuCartOpen, setMenuCartOpen] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [dropdownActive, setDropdownActive] = useState(false);

  useEffect(() => {
    const storedData = JSON.parse(localStorage.getItem("userDetails"));
    if (storedData && storedData.accessToken) {
      setIsLoggedIn(true);
    }

    const handleCartUpdated = () => {
      setCartItems(JSON.parse(localStorage.getItem("cartItems")) || []);
    };

    const handleWishlistUpdated = () => {
      setWishlistItems(JSON.parse(localStorage.getItem("wishlistItems")) || []);
    };

    window.addEventListener("cartUpdated", handleCartUpdated);
    window.addEventListener("wishlistUpdated", handleWishlistUpdated);

    return () => {
      window.removeEventListener("cartUpdated", handleCartUpdated);
      window.removeEventListener("wishlistUpdated", handleWishlistUpdated);
    };
  }, []);

  const handleClick = () => {
    setDropdownActive((prevState) => !prevState);
  };

  const handleLogout = () => {
    localStorage.removeItem("userDetails");

    setTimeout(() => {
      setIsLoggedIn(false);
    }, 100);

    // Redirect to the homepage or login page after logout
    window.location.href = process.env.PUBLIC_URL + "/login";
  };

  const triggerMobileMenu = () => {
    const offcanvasMobileMenu = document.querySelector(
      "#offcanvas-mobile-menu"
    );
    offcanvasMobileMenu.classList.add("active");
  };

  const cartItemCount = cartItems.reduce(
    (total, item) => total + item.quantity,
    0
  );

  const wishlistItemCount = wishlistItems.length;

  return (
    <div className={clsx("header-right-wrap", iconWhiteClass)}>
      {/* Account Settings */}
      <div className="same-style account-setting d-none d-lg-block">
        <button className="account-setting-active" onClick={handleClick}>
          <i className="pe-7s-user-female"></i>
          {/* <i className="fa fa-shopping-cart" style={{ fontSize: "20px" }}></i> */}
        </button>
        <div className={clsx("account-dropdown", { active: dropdownActive })}>
          <ul>
            {isLoggedIn ? (
              <>
                <li>
                  <Link to={process.env.PUBLIC_URL + "/account-profile"}>
                    My Account
                  </Link>
                </li>
                <li>
                  <button
                    onClick={handleLogout}
                    style={{
                      background: "none",
                      border: "none",
                      padding: 0,
                      color: "#000",
                      cursor: "pointer",
                      fontSize: "14px",
                    }}
                  >
                    Logout
                  </button>
                </li>
              </>
            ) : (
              <>
                <li>
                  <Link to={process.env.PUBLIC_URL + "/login-register"}>
                    Register
                  </Link>
                </li>
                <li>
                  <Link to={process.env.PUBLIC_URL + "/login"}>Login</Link>
                </li>
              </>
            )}
          </ul>
        </div>
      </div>

      {/* Cart Icon */}
      <div
        className="same-style cart-wrap d-none d-lg-block"
        style={{ paddingRight: "12px" }}
      >
        <Link className="icon-cart" to={process.env.PUBLIC_URL + "/cart"}>
          <i className="fa fa-shopping-cart" style={{ fontSize: "20px" }}></i>
          <span className="count-style">{cartItemCount}</span>
        </Link>
        <MenuCart
          cartItems={cartItems}
          setCartItems={setCartItems}
          isOpen={menuCartOpen}
          onClose={() => setMenuCartOpen(false)}
        />
      </div>

      {/* Wishlist Icon */}
      <div className="same-style cart-wrap d-none d-lg-block">
        <Link className="icon-cart" to={process.env.PUBLIC_URL + "/wishlist"}>
          <i className="fa fa-heart" style={{ fontSize: "20px" }}></i>
          <span className="count-style">{wishlistItemCount}</span>
        </Link>
      </div>

      {/* Mobile Menu */}
       <div className="same-style account-setting d-block d-lg-none">
        <button
          className="account-setting-active"
          onClick={handleClick}
        >
          <i className="pe-7s-user-female"></i>

        </button>
        <div className={clsx("account-dropdown", { active: dropdownActive })}>
          <ul>
            {isLoggedIn ? (
              <>
                <li>
                  <Link to={process.env.PUBLIC_URL + "/account-profile"}>
                    My Account
                  </Link>
                </li>
                <li>
                  <button
                    onClick={handleLogout}
                    style={{
                      background: "none",
                      border: "none",
                      padding: 0,
                      color: "#000",
                      cursor: "pointer",
                      fontSize: "14px",
                    }}
                  >
                    Logout
                  </button>
                </li>
              </>
            ) : (
              <>
                <li>
                  <Link to={process.env.PUBLIC_URL + "/login-register"}>
                    Register
                  </Link>
                </li>
                <li>
                  <Link to={process.env.PUBLIC_URL + "/login"}>Login</Link>
                </li>
              </>
            )}
          </ul>
        </div>
      </div>
      <div className="same-style mobile-off-canvas d-block d-lg-none">
        <Link className="icon-cart" to={process.env.PUBLIC_URL + "/cart"}>
          <i className="fa fa-shopping-cart" style={{ fontSize: "18px" }}></i>
          <span className="count-style" style={{ fontSize: "19px" , color:'#E43761'}}>{cartItemCount}</span>
        </Link>
      </div>

      <div className="same-style mobile-off-canvas d-block d-lg-none">
        <Link className="icon-cart" to={process.env.PUBLIC_URL + "/wishlist"}>
          <i className="fa fa-heart" style={{ fontSize: "18px"}}></i>
          <span className="count-style" style={{ fontSize: "19px" , color:'#E43761'}}>{wishlistItemCount}</span>
        </Link>
      </div> 

      {/* New mobile menu with iphone 13 fix */}
      {/* <div className="same-style mobile-off-canvas d-block d-lg-none">
        <Link className="icon-cart" to={process.env.PUBLIC_URL + "/cart"}>
          <div className="icon-wrapper" style={{ position: "relative" }}>
            <i className="fa fa-shopping-cart" style={{ fontSize: "20px" }}></i>
            <span className="count-style">{cartItemCount}</span>
          </div>
        </Link>
      </div>

      <div className="same-style mobile-off-canvas d-block d-lg-none">
        <Link className="icon-cart" to={process.env.PUBLIC_URL + "/wishlist"}>
          <div className="icon-wrapper" style={{ position: "relative" }}>
            <i className="fa fa-heart" style={{ fontSize: "20px" }}></i>
            <span className="count-style">{wishlistItemCount}</span>
          </div>
        </Link>
      </div> */}




      <div className="same-style mobile-off-canvas d-block d-lg-none">
        <button className="mobile-aside-button" onClick={triggerMobileMenu}>
          <i className="fa fa-bars" style={{ fontSize: "20px" }}></i>
        </button>
      </div>
    </div>
  );
};

IconGroup.propTypes = {
  iconWhiteClass: PropTypes.string,
};

export default IconGroup;
